/**
 * Google Tag Manager検知用にボタンにユニークな名前をつける
 * @see https://drive.google.com/file/d/1hB4DvxqhvVseVEbf_Ih4E5tsuiqctWpy/view
 * @see task https://sonicmoov.backlog.jp/view/SMV_NHKTEXT-256
 */

export const GTM_TOP_SNS = {
  FACEBOOK: 'top-sns-facebook',
  TWITTER: 'top-sns-twitter',
  INSTAGRAM: 'top-sns-instagram',
  LINE: 'top-sns-line',
};
export const GTM_TOP_GAME_START = 'top-game-start';

// game
export const GTM_GAME_START = 'game-start';

// survey
export const GTM_SURVEY_START = 'survey-start';
export const GTM_SURVEY_WATCH_RESULT = 'survey-watch-result';
export const GTM_SURVEY_NEXT = 'survey-next';

export const GTM_RESULT_SNS = {
  FACEBOOK: 'result-sns-facebook',
  TWITTER: 'result-sns-twitter',
  INSTAGRAM: 'result-sns-instagram',
  LINE: 'result-sns-line',
};
export const GTM_RESULT_GAME_AGAIN = {
  NORMAL_HERO_SECTION: 'result-game-again-normal-hero-section',
  NORMAL_RANKING_SECTION: 'result-game-again-normal-ranking-section',
};
export const GTM_RESULT_RECOMMEND_SURVEY = 'result-recommend-survey';
